import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const articleRequest = {
  fetchAwardsApplications: lazyModuleMethod(
    () => import('./fetchAwardsApplications'),
    'default'
  ),
  fetchAwardApplication: lazyModuleMethod(
    () => import('./fetchAwardApplication'),
    'default'
  ),
  changeAwardApplication: lazyModuleMethod(
    () => import('./changeAwardApplication'),
    'default'
  ),
  approvedAwardApplication: lazyModuleMethod(
    () => import('./approvedAwardApplication'),
    'default'
  ),
}
